import {Injectable} from '@angular/core';
import {
  ContactPayload, Contacts
} from '@capacitor-community/contacts';
import {Capacitor} from '@capacitor/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {uniqBy} from "lodash";

import {SbpUtilService} from "@core/services/sbp/sbp-util.service";
import {maskitoTransform} from "@maskito/core";
import {MaskUtilService} from "@core/services/utils/mask-util.service";
import {FormSelectOption} from "@shared/models/transfer/form-field.model";

@UntilDestroy()
@Injectable()
export class ContactsService {

  constructor(
  ) {
  }

  async getContacts() {
    //TODO хардкода для теста на вебе
    if (!Capacitor.isNativePlatform()) return [{caption: 'Антон', value: '+79160156622', maskedValue: '+7 (916) 015-66-22'}, {caption: 'Антон А', value: '+79089959966', maskedValue: '+7 (908) 995-99-66'}];

    const status = await Contacts.requestPermissions();

    if (status.contacts == 'granted') {
      return Contacts.getContacts({
        projection: {
          name: true,
          phones: true,
          image: true
        }
      }).then((data) => this.formatData(data.contacts));
    }

  }

  formatData(contacts: ContactPayload[]): FormSelectOption[] {
        const list = [];

        const notEmptyContacts = contacts.filter((contact) => contact.phones);
        notEmptyContacts.forEach((contact) => {
            contact.phones.forEach((phone) => {
                const value = SbpUtilService.formatClipboardPhone(phone.number);
                if (SbpUtilService.isRussianCode(value[1])) {
                  list.push({
                    caption: contact.name?.display || phone.number,
                    value,
                    maskedValue: maskitoTransform(value, {mask: MaskUtilService.phoneRurMask}),
                    // image: contact.image //TODO: Можно добавить аватарки
                  });
                }
            });
        });
        const uniqList = uniqBy(list, 'value');
        uniqList.sort((a, b) => (a.caption > b.caption ? 1 : b.caption > a.caption ? -1 : 0));
        return uniqList;
    }

}
